import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { Waypoint } from 'react-waypoint';
import { ButtonPrimary, ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { ExperienceTransferSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import { routeConstants } from 'app/routes/route-constants';
import {
  experienceTransferDefaultFilters, experienceTransferFilters,
  experienceTransferPredefinedFilters, experienceTransferQueryFilters
} from 'app/area/experience-transfer/list/filter-configuration';
import styles from './list-renderer.scss';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, translation, loadList, deleteExperienceTransfer
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults, deletingExperienceTransfer } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: ExperienceTransferSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const onCreate = () =>
    navigate.replace(routeConstants.experienceTransferAddFor());

  const topToolbar = <div className="col-lg-8 col-md-12">
    <h1>{translation.experience_transfer}</h1>
  </div>;

  const rightToolbar = <ButtonPrimary
    id={'add-new-experience-transfer'}
    onClick={onCreate}>
    {translation.add_new}
  </ButtonPrimary>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      filtersConfig={{ area: 'experienceTransferConfiguration' }}
      queryFilters={experienceTransferQueryFilters(translation)}
      predefinedFilters={experienceTransferPredefinedFilters(translation)}
      customFilters={experienceTransferFilters(translation)}
      defaultFilterValues={experienceTransferDefaultFilters(translation)}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="experience_transfer_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_experience_transfer
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          deletingExperienceTransfer={deletingExperienceTransfer}
          deleteExperienceTransfer={deleteExperienceTransfer}
          translation={translation} />
        : null}
      <Waypoint key="wpExperienceTransferAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
